module.exports = __webpack_public_path__ + "media/assets/images/flags/bm-231c15b194d999485a6e60d2da676aeb.svg";